import { Service } from '@/tools'

export class ExcelService<T extends TCommodity.Excel> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Excel}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }

  // /api/commodity/exchangeRate/v1/page
  importTaxRate = <K extends T['ApiImportTaxRate']>(data: K['req']): Promise<K['res']> => this.postUpload('v1/ApiImportTaxRate', data)
}
